import { styled } from '@linaria/react';

export const StyledCardPlaceholderList = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
  overflow-x: auto;
  margin: 1.5rem 0 4rem;
`;

export const StyledCardPlaceholderItem = styled.div`
  flex: 1 1 0;
  min-width: 0;

  & > * {
    width: 100%;
  }
`;
